import {PSR_TYPES} from '../../constants/typesMessages';
import {formatCnpj, removeMaskCnpj} from '../../utils';
import {checkIdFiservAlianca} from '../psrAlianca';
import {checkIdiFood, prepareAdyebAndIFoodToSend} from '../iFoodPsr';

export const getCodeFilled = (chatStateListCodePsr, psrId) => {
  let psrItemFilled = chatStateListCodePsr.filter(
    (psrItem) => psrItem.id === psrId
  );
  return psrItemFilled.length ? psrItemFilled[0].idMultivan : '';
};

export const prepareListPsrSelected = (chatStateListCodePsr) => {
  let newPsrList = chatStateListCodePsr.map((psr) => {
    let newId = checkIdiFood(psr.id);
    newId = checkIdFiservAlianca(newId);
    return {psr: newId, code: removeMaskCnpj(psr.idMultivan)};
  });

  return prepareAdyebAndIFoodToSend(newPsrList);
};

export const getPsrCode = (psrItem, listCodePsr, cnpj) => {
  if (psrItem.isIdMultivanCnpj) {
    return cnpj ? formatCnpj(cnpj) : '';
  }
  return getCodeFilled(listCodePsr, psrItem.id);
};

export const sendMessageGetFirstPsrTypeSelected = (physical) => {
  if (physical) {
    return {
      type: PSR_TYPES.PSR_PHYSICAL
    };
  }

  return {
    type: PSR_TYPES.PSR_ECOMMERCE
  };
};
